export const RECOMMENDATIONS_MODE = {
  saved: 'saved',
  edit: 'edit',
} as const
